export { toast } from 'sonner';

/** Shared toast message labels for consistent copy across apps */
export const toastMessages = {
  promoter: {
    created: 'Promoter created',
    updated: 'Promoter updated',
    deleted: 'Promoter deleted',
  },
  prospect: {
    created: 'Prospect created',
    updated: 'Prospect updated',
    deleted: 'Prospect deleted',
  },
  vendor: {
    created: 'Vendor created',
    updated: 'Vendor updated',
    deleted: 'Vendor deleted',
  },
  generic: {
    saved: 'Changes saved',
    error: 'Something went wrong',
  },
} as const;
